// Description: Colors for the application
export default {
    transparent: "transparent",
    black: "#081222",
    white: "#FFF",
    text: "#1B1B1B",
    primary: {
        DEFAULT: "#0E7AD9",
        "lighter-blue": "#EEFAFF",
        "light-blue": "#0E7AD9",
        "blue": "#19587A",
        "alt-dark": "#152948",
        "dark": "#081222",
        "red": "#CF202E",
        "lighter-purple": "#EFEBFF",
        "purple": "#8A38F5",
        "lighter-green": "#EDFFF4",
        "green": "#22C55E",
        "warning": "#FAB637",
        "warning-dark": "#E35C10",
    },
    neutral: {
        0: "#FFFFFF",     // Neutral/0 (white)
        25: "#FAFAFA",    // Neutral/25
        50: "#E7EAF0",    // Neutral/50
        100: "#CFD5E2",   // Neutral/100
        200: "#9AA4B7",   // Neutral/200
        300: "#636D83",   // Neutral/300
        400: "#323C4F",   // Neutral/400
        500: "#151C2A",   // Neutral/500
        600: "#081222",   // Neutral/600
    },
    gray: {
        50: "#FAFAF9",
        100: "#E6E6E6",
        200: "#CCCCCC",
        300: "#B3B3B3",
        400: "#999999",
        500: "#999999",
        600: "#666666",
        700: "#4D4D4D",
        800: "#333333",
        900: "#1A1A1A",
    },
};
